/**
 * SectionPadding is a functional component that adds padding to a section.
 *
 * @param {string} padding - The size of the padding to be applied. Default is '20px'.
 *
 * @returns {JSX.Element} A div element with the specified padding.
 *
 * @example
 * <SectionPadding padding="50px" />
 *
 */ import { jsx as _jsx } from "react/jsx-runtime";
export default function SectionPadding({ padding = "20px" }) {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            height: padding
        }
    });
}
